import BooleanWithLabel from "@/Components/Boolean/BooleanWithLabel";
import Button from "@/Components/Button/Button";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import usePosSettingsMutation from "@/shared/mutations/pos/usePosSettingsMutation";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BackButton from "@/Components/Button/BackButton";
import { useSetPosShowSettings } from "@/shared/atoms/usePosShowSettings.js";

const PosOrderSettings = () => {
  const { t } = useTranslation();
  const setShowSettings = useSetPosShowSettings();
  const mutation = usePosSettingsMutation();
  const { settings, refetch: refetchSettings } = usePosSettingsHook();
  const { handleSubmit, control } = useForm({});

  const onSubmit = (data) => {
    const submitData = {
      ...data,
      item_id: settings.item_id,
    };

    mutation.mutateAsync(submitData).then(() => {
      refetchSettings();
      setShowSettings(false);
    });
  };

  const booleans = [
    ["voip_is_active", t("posOrders.voip")],
    ["show_product_images", t("posOrders.showProductImage")],
    ["accept_all_addresses", t("posOrders.acceptAllAddress")],
    ["accept_all_times_for_pos", t("posOrders.acceptAllTimes")],
    ["reset_delivery_method", t("posOrders.resetDeliveryMethod")],
  ];

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-0">
      <div className="mb-4 flex items-center justify-between">
        <BackButton onClick={() => setShowSettings(false)}>
          {t("back")}
        </BackButton>
        <Button isPending={mutation.isPending}>{t("posOrders.save")}</Button>
      </div>
      <div className="mb-4 grid grid-cols-1 gap-8 rounded-2xl bg-white p-8 md:grid-cols-3">
        {booleans.map(([name, label]) => (
          <Controller
            key={name}
            defaultValue={settings[name]}
            name={name}
            control={control}
            render={({ value, onChange }) => {
              return (
                <BooleanWithLabel
                  checked={value}
                  onChange={() => onChange(!value)}
                >
                  {label}
                </BooleanWithLabel>
              );
            }}
          />
        ))}
      </div>
    </form>
  );
};

export default PosOrderSettings;
